import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { getCustomerAddress, getCustomerSearch } from "./utilities";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { LoadingState } from "../../UI/States";

const FRM_SelectCustomer = (props) => {
  const [customerSearch, setCustomer] = useState("");
  const [searchResults, setResults] = useState(null);
  const [customerSearchModal, setSearchModal] = useState(false);
  const [customerAddress, setCustomerAddress] = useState(null);
  const [customerAddressModal, setAddressModal] = useState(false);

  function openModal() {
    setSearchModal(true);
  }

  function closeModal() {
    setSearchModal(false);
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = () => {
    if (customerSearch !== "") {
      openModal();
      getCustomerSearch(setResults, customerSearch);
    }
  };

  const fieldLabel = "mb-1 block text-sm font-medium";

  return (
    <>
      <Dialog
        open={customerSearchModal}
        onClose={() => {
          closeModal();
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Search Results - "{customerSearch}"</DialogTitle>
        <DialogContent>
          {searchResults === null ? (
            <LoadingState label="Searching Bistrack…" className="py-10" />
          ) : searchResults?.length === 0 ? (
            <p className="app-muted py-6 text-center text-sm">
              No customers matched.
            </p>
          ) : (
            <ul className="app-surface divide-y divide-[color:var(--app-divider)] overflow-hidden rounded-xl border">
              {searchResults?.map((item, index) => {
                return (
                  <li key={index}>
                    <button
                      type="button"
                      className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left text-sm transition hover:bg-[color:var(--app-hover)]"
                      onClick={() => {
                        setAddressModal(true);
                        getCustomerAddress(setCustomerAddress, item.CustomerID);
                        props.setFormData({
                          ...props.formData,
                          account: item.CustomerID,
                          customer: item.Name,
                        });
                        closeModal();
                      }}
                    >
                      <span className="min-w-0 truncate font-medium">
                        {item.Name}
                      </span>
                      <ArrowForwardIcon
                        className="app-muted shrink-0"
                        sx={{ fontSize: 18 }}
                      />
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={customerAddressModal}
        onClose={() => {
          setAddressModal(false);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{props.formData.customer} Addresses</DialogTitle>
        <DialogContent>
          {customerAddress?.length === 0 && (
            <p className="app-muted py-6 text-center text-sm">
              No Addresses Found
            </p>
          )}
          {customerAddress?.length > 0 && (
            <ul className="app-surface divide-y divide-[color:var(--app-divider)] overflow-hidden rounded-xl border">
              {customerAddress?.map((item, index) => {
                return (
                  <li key={index}>
                    <button
                      type="button"
                      className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left text-sm transition hover:bg-[color:var(--app-hover)]"
                      onClick={() => {
                        props.setFormData({
                          ...props.formData,
                          address: item.FormatedAddress,
                          job: item.CustomerAddress.split(" ")[0],
                          imported_customer: true,
                        });
                        setAddressModal(false);
                      }}
                    >
                      <span className="min-w-0">{item.CustomerAddress}</span>
                      <ArrowForwardIcon
                        className="app-muted shrink-0"
                        sx={{ fontSize: 18 }}
                      />
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </DialogContent>
      </Dialog>

      <div className="app-surface rounded-xl border p-4">
        <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm font-semibold">Customer Information</p>
          {props.formData.imported_customer && (
            <Tooltip title="Clear imported customer and enter manually">
              <button
                type="button"
                onClick={() => {
                  props.setFormData({
                    ...props.formData,
                    customer: "",
                    account: "",
                    job: "",
                    address: "",
                    imported_customer: false,
                  });
                  setCustomer("");
                }}
                className="app-btn app-btn-ghost app-btn-sm text-rose-600 dark:text-rose-300"
              >
                Clear
              </button>
            </Tooltip>
          )}
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <p className={fieldLabel}>Customer Name</p>
            <TextField
              fullWidth
              size="small"
              disabled={props.formData.imported_customer ? true : false}
              onChange={(e) => {
                props.setFormData({
                  ...props.formData,
                  customer: e.target.value,
                });
                setCustomer(e.target.value);
              }}
              value={props.formData.customer || ""}
              variant="outlined"
              onKeyDown={handleKeyDown}
              inputProps={{ "aria-label": "Customer Name" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Search Bistrack for Customer">
                      <IconButton
                        edge="end"
                        size="small"
                        aria-label="Search Bistrack for Customer"
                        onClick={() => {
                          handleSearch();
                        }}
                      >
                        <SearchIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div>
            <p className={fieldLabel}>Account Number</p>
            <TextField
              fullWidth
              size="small"
              onChange={(e) => {
                props.setFormData({ ...props.formData, account: e.target.value });
              }}
              value={props.formData.account || ""}
              variant="outlined"
              inputProps={{ "aria-label": "Account Number" }}
            />
          </div>
          <div>
            <p className={fieldLabel}>Job Number</p>
            <TextField
              fullWidth
              size="small"
              onChange={(e) => {
                props.setFormData({
                  ...props.formData,
                  job: e.target.value,
                });
              }}
              value={props.formData.job || ""}
              variant="outlined"
              inputProps={{ "aria-label": "Job Number" }}
            />
          </div>
          <div>
            <p className={fieldLabel}>Delivery Address</p>
            <TextField
              fullWidth
              size="small"
              onChange={(e) => {
                props.setFormData({ ...props.formData, address: e.target.value });
              }}
              value={props.formData.address || ""}
              variant="outlined"
              inputProps={{ "aria-label": "Delivery Address" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FRM_SelectCustomer;
